module.exports = __webpack_public_path__ + "img/scenes_3.c0e20f93.png";